const LoanExerciseDataset =[
      {exerciseName: "LoanAmount", 
              text:  "In this example, only the Loan Amount has been changed.  The Interest Rate and Loan Term " +
                     "are the same for each of the lines.  Note that the Monthly Amount increases as the Loan Amount " +
                     "is increased.  The Monthly Amount is the amount that the borrower has to pay each month.  Also, " +
                     "the Total Amount Paid increases as the Loan Amount increases.",
              conclusion: "Loans where the loan amount is larger will result in a larger monthly payment amount.",       
              parametersArr: [{intRate: 5, loanAmount: 5000, nbrYears: 10},
                                   {intRate: 5, loanAmount: 10000, nbrYears: 10},
                                   {intRate: 5, loanAmount: 20000, nbrYears: 10},
                                   {intRate: 5, loanAmount: 40000, nbrYears: 10},
                                   {intRate: 5, loanAmount: 100000, nbrYears: 10}
                            ]   
      },
      {exerciseName: "InterestRate", 
              text:  "In this example, only the Interest Rate has been changed.  The Loan Amount and Loan Term " +
                     "are the same for each of the lines.  Note that the Monthly Amount increases as the Interest Rate " +
                     "is increased.  The Monthly Amount is the amount that the borrower has to pay each month until the " +
                     "loan is fully paid back.  Also, the Total " +
                     "Amount Paid increases as the Interest Rate increases.  Line 5 shows that the individual got a " +
                     "loan for $5000 but ended up having to pay $8,608.80.  This means they had to pay $3,608.80 more " +
                     "than they borrowed in order to fully pay back the loan.",
              conclusion: "Loans that have a lower interest rate, will result in lower monthly payments and " +
                     "the amount overpaid will be reduced.",
              parametersArr: [{intRate: 2, loanAmount: 5000, nbrYears: 10},
                                   {intRate: 5, loanAmount: 5000, nbrYears: 10},
                                   {intRate: 7, loanAmount: 5000, nbrYears: 10},
                                   {intRate: 10, loanAmount: 5000, nbrYears: 10},
                                   {intRate: 12, loanAmount: 5000, nbrYears: 10}
                            ]   
      },
      {exerciseName: "LoanTerm", 
              text:  "In this example, only the Loan Term has been changed.  The Loan Amount and Interest Rate " +
                     "are the same for each of the lines.  Note that the Monthly Amount decreases as the Loan Term " +
                     "is increased.  So one way to reduce the amount you have to pay each month, is to get a loan " +
                     "that has a longer Loan Term.  However, it is " +
                     "important to understand that the longer Loan Term will increase the Total " +
                     "Amount Paid (this is because the Interest Rate is applied for a longer period of time).",
              conclusion: "Increasing the Loan Term will reduce the monthly loan payment amount but will " +
                     "increase the overpayment amount.",
              parametersArr: [{intRate: 5, loanAmount: 500000, nbrYears: 5},
                                   {intRate: 5, loanAmount: 500000, nbrYears: 10},
                                   {intRate: 5, loanAmount: 500000, nbrYears: 15},
                                   {intRate: 5, loanAmount: 500000, nbrYears: 20},
                                   {intRate: 5, loanAmount: 500000, nbrYears: 30}
                                   ]   
       },
       {exerciseName: "PayDay", 
              text:  "In this example, the factor values reflect examples of typical pay day loans. " +
                     "Note the very large interest rate.  Even though the loan term is fairly short, " +
                     "the total amount paid is quite a bit more than the original loan. PayDay loans " +
                     "typically charge an interest rate from 300% to over 600% and the term is " +
                     "2 to 4 weeks.  The over payment amount is bad enough after 2 to 4 weeks, but " +
                     "line 3 indicates what happens if you aren't able to pay back the loan until 6 " +
                     "weeks... Yep, you would really end up paying an extra $345.21 for a $1000 loan...YIKES!",
              conclusion: "You can get 'easy money' with a pay day loan, but it is VERY costly! ",
              //  the nbrYears in payDay loans is actually used as nbrDays!!!
              parametersArr: [{intRate: 300, loanAmount: 1000, nbrYears: 14},
                              {intRate: 300, loanAmount: 1000, nbrYears: 28},
                              {intRate: 300, loanAmount: 1000, nbrYears: 42},
                              {intRate: 600, loanAmount: 1000, nbrYears: 14},
                              {intRate: 600, loanAmount: 1000, nbrYears: 28}
                              ]   
              },
     
      
]

export default LoanExerciseDataset;